<template>
  <div class="module-box" :style="{height:height,width:width}">
    <div v-if="showChart" :id="id" class="chart-box" />
    <div v-else class="no-data">暂无数据</div>
  </div>
</template>
<script>
import echarts from 'echarts'
import resize from './mixins/resize'
export default {
  name: "FszLine",
  mixins: [resize],
  props: {
    data: {
      default() {
        return {
          chartLineData: [
            {
              name: "折线1",
              color: "#3186FF",
              data: [120, 132, 101, 134, 90, 230, 210]
            },
            {
              name: "折线2",
              color: "#FF9609",
              data: [108, 125, 148, 136, 99, 87, 148]
            }
          ],
          chartLineAxis: ['01/01','01/02','01/03','01/04','01/05','01/06','01/07'],
        }
      }
    },    
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    yAxisName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      chart: null,
      showChart:true,
      option: {
        color: ['#589DFF', '#FC7D6A', '#30C28D', '#FAC000'],
        title: {
          text: '',
          textStyle: {
            color: '#222222',
            fontSize: 14,
            lineHeight: 20
          },
          left: 24,
          top: 0
        },
        tooltip: {
          trigger: 'axis',
          
          backgroundColor: 'rgba(255,255,255,0.9)',
          borderColor: '',
          textStyle: {
            fontSize: 12,
            color: '#7D7D7D',
            lineHeight: 20
          },
          padding: 12
        },
        legend: {
          show: true,
          right: 26,
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 2,
          top: 0,
          itemGap: 26,
          textStyle: {
            fontSize: 12,
            color: '#757575',
            fontWeight: 400,
            lineHeight: 20
          },
          data: []
        },
        grid: {
          containLabel: true,
          left: 26,
          right: 30,
          top: 64,
          bottom: 10
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: {
              width: 0.5,
              color: '#BDC8D3'
            }
          },
          nameGap: 8,
          axisTick: {
            show: true,
            lineStyle: {
              width: 1,
              height: 4,
              color: '#BDC8D3'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8c8c8c',
              fontSize: 14,
              lineHeight: 14
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: this.yAxisName,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              height: 1
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          nameTextStyle: {
            color: '#222',
            fontSize: '16',
            lineHeight: 22,
            fontWeight:500,
            padding: [0, 0, 20, 0]
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8c8c8c',
              fontSize: 14,
              lineHeight: 14,
              fontFamily: 'Helvetica'
            }
          }
        },
        series: []
      }
    }
  },
  computed: {
    id() {
      return (
        'pieChart' + new Date().getTime() + Math.round(Math.random() * 100)
      )
    },
  },
  created() {
    
  },
  watch: {
    data: {
      deep: true,
      handler(newVal, oldVal) {
        console.log("newVal：",newVal)
        console.log("reload line chart")
        if(newVal.chartLineAxis.length){
          this.showChart = true
          this.initChart()
        }else{
          this.showChart = false
        }
      }
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart()
    // })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.option.series = this.keyParams().series
      this.option.legend.data = this.keyParams().legend
      this.option.xAxis.data = this.data.chartLineAxis
      if (this.option.legend.data.length > 1) {
        this.option.legend.show = true
      }
      this.chart = echarts.init(document.getElementById(this.id))
      this.chart.setOption(this.option, true)
    },
    
    keyParams() {
      const p = {
        legend: [],
        series: [],
        color: []
      }
      this.data.chartLineData.forEach(el => {
        p.color.push(el.color),
        p.legend.push({
          name: el.name,
          textStyle: {
            color: '#666666'
          }
        })
        p.series.push({
          type:'line',
          name: el.name,
          // stack: "总量",
          // symbol: 'circle',
          symbolSize: 5,
          showAllSymbol: false,
          itemStyle: {
            normal: {
              color: el.color,
              borderWidth: '1'
            }
          },
          lineStyle: {
            normal: {
              color: el.color,
              width: '1.5'
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: el.color
                },
                {
                  offset: 1,
                  color: '#ffffff'
                }
              ]),
              opacity: '0.1'
            }
          },
          data: el.data
        })
      })
      return p
    },
    delPositiveLable(val) {
      return val.toString().replace(/\-/, '')
    }
  }
}
</script>
<style scoped>
* {
  margin: 0;
}
.module-box {
  position: relative;
}
.chart-box {
  position: relative;
  height: 100%;
}
.no-data {
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(111,111,111,1);
  line-height:20px;
}
</style>